export interface RedeemCodesModelProps {
  hidePointsBalance?: boolean
  hideScanCode?: boolean
  scanCodeButtonLabel?: string
  scanCodeButtonIcon?: string
  pointsTitle?: string
}

export enum RedemptionStatus {
  InvalidCode = 'INVALID_CODE',
  SuperCodeSuccess = 'SUPER_CODE_SUCCESS',
  FirstCodeSuccess = 'FIRST_CODE_SUCCESS',
  RegularSuccess = 'REGULAR_SUCCESS',
  RegularTenCodesLeftSuccess = 'REGULAR_10_CODES_LEFT_SUCCESS',
  RegularErrorExceed = 'REGULAR_ERROR_EXCEED',
  Club36Success = 'CLUB36_SUCCESS',
  Club36TenCodesLeftSuccess = 'CLUB36_10_CODES_LEFT_SUCCESS',
  Club36ErrorExceed = 'CLUB36_ERROR_EXCEED',
  ServerError = 'SERVER_ERROR'
}

export interface CodeStatusEvent {
  status: RedemptionStatus
  receivedAt: number
}

export interface RewardRedemptionResponse {
  messageKey?: string
  availablePointsBalance?: number
  params: {
    allowedCodesPerMonth?: string
  } | null
}

/**
 * CBX Claim API wraps the payload in a `data` envelope.
 * The mock returns the flat RewardRedemptionResponse shape directly.
 * Components should handle both via: `json?.data ?? json`
 */
export interface CbxClaimResponse {
  data?: RewardRedemptionResponse
  messageKey?: string
  availablePointsBalance?: number
  params?: {
    allowedCodesPerMonth?: string
  } | null
}

export interface PageConfigModel {
  scanCodesConfig?: {
    api?: string
    uiLabels?: {
      enterCodeLabel?: string
      enterCodePlaceholder?: string
      enterCodeHelper?: string
      enterCodeTooltipMessage?: string
      submitCodeButtonLabel?: string
      enterCodesModalTitle?: string
    }
    uiLinks?: {
      contactUsPath?: string
      rewardsStorePath?: string
      enterManuallyPath?: string
      stillHaveQuestionsPath?: string
    }
    responseLabels?: {
      clubCodeEntered?: string
      clubLimitError?: string
      clubMonthlyLimit?: string
      codeLimitError?: string
      codeRedeemedSuccessfully?: string
      firstCodeRedeemed?: string
      invalidCodeError?: string
      maxCodeLimit?: string
      superCodeRedeemed?: string
      systemError?: string
    }
  }
}
